import React, { ReactNode } from 'react';
import styles from './assets/ServiceLocation-list-screen.module.scss';
import classNames from 'classnames';
import ServiceLocationsGrid from './components/ServiceLocationsGrid';
import { Paginated } from 'src/services/api-handlers/pagination';
import { QueryParams } from 'src/types/grid';
import CreateServiceLocationButton from './components/CreateServiceLocationButton';
import AdminLayout from 'src/components/layout/RoleLayout';
import { IServiceLocation } from 'src/types/service-locations';
import Loader from '../../../../../../components/Loader';

export interface StateProps {
    data: Paginated<IServiceLocation>;
    inProgress: boolean;
}

export interface DispatchProps {
    getData: (params: QueryParams) => void;
}

export interface OwnProps {}

export interface Props extends StateProps, DispatchProps, OwnProps {}

class ServiceLocationListScreen extends React.Component<Props> {
    public render(): ReactNode {
        const { data, getData, inProgress } = this.props;

        return (
            <AdminLayout>
                {inProgress ? <Loader /> : null}
                <div className={`${classNames(styles.WrapPage)}`}>
                    <div className={`${classNames(styles.pageHeading)} ${'pageHeading'}`}>
                        <h2 className={`${classNames(styles.pageHeadingTitle)} ${'pageHeadingTitle'}`}>
                            SERVICE LOCATIONS {data.totalCount ? '(' + data.totalCount + ')' : ''}
                        </h2>
                        <CreateServiceLocationButton />
                    </div>
                    <div className={classNames(styles.list)}>
                        <ServiceLocationsGrid data={data} getData={getData} />
                    </div>
                </div>
            </AdminLayout>
        );
    }
}

export default ServiceLocationListScreen;
